//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['tableData'],
  data: function data() {
    return {
      tagsList: [],
      childSelect: ''
    };
  },
  methods: {
    selectRow: function selectRow() {
      console.log('xxx');
    }
  },
  watch: {},
  mounted: function mounted() {}
};